import { dataShoppingBag } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShoppingBag = /*#__PURE__*/createIcon(dataShoppingBag)
export default IconShoppingBag
